import { saveEditorState } from '~core';

export const onSaveCanvasBtnClick = async (event) => {
  event.preventDefault();
  await saveEditorState(true, true);
};
